// Legal identity shared by the JSON-LD schemas, the footer and llms-full.txt.
export const ORGANIZATION_NAME = "Réassurez-moi"
export const ORGANIZATION_LEGAL_NAME = "Réassurez-moi SAS"
export const ORGANIZATION_URL = "https://reassurez-moi.fr"
export const ORGANIZATION_SCHEMA_ID = `${ORGANIZATION_URL}/#organization`
export const ORGANIZATION_LOGO_URL = `${ORGANIZATION_URL}/logo_RM_200px.png`
export const ORGANIZATION_FOUNDING_YEAR = "2013"
export const ORGANIZATION_FOUNDER = "Antoine Fruchard"

export const ORIAS_NUMBER = "13010052"
export const ORIAS_REGISTER_URL = "https://www.orias.fr"
export const SIREN_NUMBER = "797863933"
export const RCS_LABEL = "RCS Paris 797 863 933"
export const VAT_NUMBER = "FR23797863933"

export const ORGANIZATION_SAME_AS = [
    "https://www.linkedin.com/company/reassurez-moi",
    "https://twitter.com/reassurezmoi",
    "https://www.instagram.com/reassurezmoi.fr/",
    "https://www.facebook.com/reassurezmoi/",
    "https://www.youtube.com/@ReassurezmoiFr1/",
    "https://www.tiktok.com/@reassurezmoi",
    "https://www.avis-verifies.com/avis-clients/reassurez-moi.fr",
    "https://www.cbinsights.com/company/reassurez-moi",
]
